import React, {useMemo} from 'react'
import PageLayout from '../../components/layout/PageLayout'
import TableHeader from '../../components/table/TableHeader'
import Text from '../../components/text/Text'
import TableLayout from '../../components/table/TableLayout'
import TableItem from '../../components/table/TableItem'
import useNavigation from '../../hooks/useNavigation'
import WizImage from '../../components/image/WizImage'
import {useImage} from '../../utils/image'
import {useTime} from '../../utils/time'
import useQueryPointRetractList from "../../hooks/api/point/useQueryPointRetractList";
import {IUserRetractPointHistory} from "../../apis/point/getUserRetractPointHistory";

interface IProps {
    className?: string
}

const PointRetractPage: React.FC<IProps> = ({className}) => {
    const {data} = useQueryPointRetractList()
    const {goUserDetail} = useNavigation()
    const {renderThumbnail} = useImage()
    const {convertUtc0ToUtc9} = useTime()

    const list = useMemo(() => {
        const list: IUserRetractPointHistory[] = []
        data?.pages?.map(page => page?.map(item => list?.push(item)))
        return list
    }, [data])

    return (
        <PageLayout title={'Point Retract'} className={`${className}`}>
            <TableHeader className={'grid-cols-[1fr_2fr_1fr_1fr_1fr] md:hidden lg:gap-x-[10px] mt-[10px]'}>
                <Text>User</Text>
                <Text>Reason</Text>
                <Text className={'text-center'}>Amount</Text>
                <Text className={'text-center'}>Manager</Text>
                <Text className={'text-right'}>Retract At</Text>
            </TableHeader>
            <TableLayout>
                {list?.map((item, idx) => (
                    <>
                        <TableItem
                            key={idx}
                            className={'grid-cols-[1fr_2fr_1fr_1fr_1fr] md:block lg:gap-x-[10px] sm:px-[22px]'}
                            onClick={() => goUserDetail(item?.user_id)}>
                            <div className={'flex items-center gap-x-[10px]'}>
                                <WizImage src={renderThumbnail(item?.user_thumbnail)} className={'w-[30px]'} />
                                <Text className={'text-ti2'}>{item?.user_name}</Text>
                            </div>
                            <div className={'flex gap-x-[5px]'}>
                                <Text className={'text-ti2 text-font_red'}>[{item?.reason?.split(' - ')?.at(0)}]</Text>
                                <Text className={'text-ti2'}>{item?.reason?.split(' - ')?.at(1)}</Text>
                            </div>
                            <div>
                                <Text className={'text-ti2 text-font_red text-center'}>{item?.amount} LP</Text>
                            </div>
                            <div className={'justify-center flex items-center gap-x-[10px]'}>
                                <WizImage src={renderThumbnail(item?.manager_thumbnail)} className={'w-[30px]'} />
                                <Text className={'text-ti2'}>{item?.manager_name}</Text>
                            </div>
                            <div className={'text-right'}>
                                <Text className={'text-font02'}>{convertUtc0ToUtc9(item?.created_at)}</Text>
                            </div>
                        </TableItem>
                    </>
                ))}
            </TableLayout>
        </PageLayout>
    )
}

export default PointRetractPage
